// ENUMS

export enum CodeTypes {
  PROMO = 'Promo',
  REFERRAL = 'Referral'
}
